import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { TextInput, PhoneNumberInput, TextAreaInput } from 'hosman-material';

import { updateFormValues, updateErrors } from '../../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const ContactForm = () => {
  const { user } = useSelector((state) => state.user);
  const { newPhotoMeetingParams: { formValues, errors }} = useSelector((state) => state.sellerPhotoMeetings);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateFormValues({
      contact_name: user.first_name,
      last_name: user.last_name,
      contact_phone_number: user.phone_number,
      contact_phone_country_code: user.phone_country_code || 'FR'
    }))
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateFormValues({...formValues, [name]: value}));
    dispatch(updateErrors({ ...errors, [name]: null }));
  };

  if (!formValues.contact_phone_country_code) return null;

  return (
    <div className='flex flex-col gap-6'>
      <p className='h2'>Point de contact pour le prestataire</p>

      <div className='flex flex-col md:flex-row gap-3'>
        <TextInput label='Prénom' name='contact_name' value={formValues.contact_name} onChange={handleInputChange} errors={errors} />
        <TextInput label='Nom' name='last_name' value={formValues.last_name} onChange={handleInputChange} />
      </div>
      
      <div className='md:w-1/2'>
        <PhoneNumberInput
          name='contact_phone_number'
          onChangePhone={(val) => handleInputChange({ target: { name: 'contact_phone_number', value: val }})}
          onChangeCountryCode={(val) => handleInputChange({ target: { name: 'contact_phone_country_code', value: val }})}
          phoneValue={formValues.contact_phone_number}
          countryCodeValue={formValues.contact_phone_country_code}
          errors={errors}
        />
      </div>
      
      <TextAreaInput rows={3} label="Informations d'accès pour le prestataire (digicodes, bâtiment, code...)" name='access_details' value={formValues.access_details} onChange={handleInputChange} errors={errors} />
    </div>
  )
}

export default ContactForm;
